import React from 'react'
import { ActivationObjectContext } from '../constants/index'

const useActivationObject = () => React.useContext(ActivationObjectContext)
export default useActivationObject
